import { type FC } from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { IconSwipeUp } from 'assets/svg/sprite'
import { AudioMessagePost, LastPostInfo } from 'components-ref/molecules'
import { AudioMinimized } from 'components-ref/molecules/post/Minimized'
import { usePreviewContext } from 'context/previewContext'
import { MinimizeIcon } from 'features/Preview/Preview'
import { useOrientation } from 'helpers/helperHooks'
import colors from 'styles/colors'
import { type IFile } from 'types/interfaces/IFile'
import { type IPost, type IPostFile } from 'types/interfaces/ITypes'

interface Props {
    mediaItem: IFile
    postFile: IPostFile
    minimized: boolean
    isFirstPost: boolean
    isActive: boolean
    showControls: boolean
    toggleControls: () => void
    hasNextPage: boolean
    isLastPost?: boolean
    minimizeFn: (index: number, name: string) => void
    post: IPost
    index: number
}

const SinglePostPreviewAudio: FC<Props> = ({
    mediaItem,
    postFile,
    minimized,
    showControls,
    hasNextPage,
    isLastPost = false,
    minimizeFn,
    post,
    index
}) => {
    const deviceOrientation = useOrientation()
    const { t } = useTranslation()

    if (!deviceOrientation) return null
    return (
        <>
            <div
                className={classNames(
                    'preview__file',
                    !minimized && 'preview__file__sound'
                )}
            >
                <MinimizeIcon
                    {...{ minimized, post, showControls }}
                    onClick={() => {
                        minimizeFn(index, 'sound')
                    }}
                    outlineColor={minimized ? '#53aff7' : colors.white}
                />
                {minimized ? (
                    <AudioMinimized
                        mediaUrl={mediaItem.url}
                        postFile={postFile}
                    />
                ) : (
                    <>
                        <div className='preview__file__sound--container'>
                            <AudioMessagePost mediaUrl={mediaItem.url} />
                        </div>
{/*                         {shouldShowFirstTourGuide() && (
                            <div className='preview__swipe--icon'>
                                <IconSwipeUp
                                // opacity={
                                //   deviceOrientation.type.includes(
                                //     'portrait'
                                //   )
                                //     ? orientation === 'landscape'
                                //       ? 0.5
                                //       : 1
                                //     : 1
                                // }
                                />
                                <p
                                // style={{
                                //   opacity:
                                //     deviceOrientation.type.includes(
                                //       'portrait'
                                //     )
                                //       ? orientation === 'landscape'
                                //         ? 0.5
                                //         : 1
                                //       : 1,
                                // }}
                                >
                                    {t('swipeUpForNextPost')}
                                </p>
                            </div>
                        )} */}
                    </>
                )}
                {isLastPost && !hasNextPage && <LastPostInfo />}
            </div>
        </>
    )
}

export default SinglePostPreviewAudio
